// Exports the injector
export { injector } from './core/injector';

// Exports the types
export { AuthStoreState, StoreState } from './core/types';

export {
  FORGOT_PASSWORD_ROUTE,
  FORGOT_PASSWORD_SENT_ROUTE,
  LOGIN_ROUTE,
  LOGOUT_ROUTE,
  MFA_ROUTE,
  MFA_SELECTION_ROUTE,
  REGISTER_ROUTE,
  REGISTER_BY_PRODUCT_ROUTE,
  REGISTERED_ROUTE,
  REGISTERED_BY_PRODUCT_ROUTE,
  RESET_PASSWORD_CODE_USER_ROUTE,
  VERIFY_ROUTE,
  VERIFY_CODE_USER_BY_PRODUCT_ROUTE,
  VERIFIED_ROUTE,
  VERIFIED_BY_PRODUCT_ROUTE,
  VERIFY_CODE_USER_ROUTE,
  INVITE_USER_ROUTE,
  SSO_EMBED_TRIGGER
} from './core/constants';

// Exports the helpers and the main component
export { authReducers } from './core/root-reducer';
export { AuthContainer as AuthComponent } from './auth/containers/auth-container';
export { signOut } from './login/redux-utils/actions';
export { ELOQUA_LS_COUNTRY_KEY, ELOQUA_LS_OPTED_INTO_MARKETING_KEY, sendEloquaRequest } from './utils/eloqua';

// Exports ActionSets
export { SIGN_OUT } from './login/constants';

// Exports selectors
export {
  getFullNameSelector,
  getGivenNameSelector,
  getFamilyNameSelector,
  getIsSageIdSelector,
  getIsSxpManagedSelector,
  getBusinessPhoneNumberSelector,
  getBusinessTypeSelector
} from './core/redux-utils/selectors';

export { checkIfAuthenticated } from './auth/service';

export { MyProfile } from './my-profile/my-profile';
